module.exports = __webpack_public_path__ + "static/img/PH@3x.bbe72be9.jpg";